import {
  TsrctQuoteItemStatus,
  TsrctSourcingCaseQuoteItemBidDeclineReason,
  TsrctSourcingCaseQuoteItemNegotiationFailedReason,
  TsrctSourcingCaseQuoteItemStatus,
  TsrctSupplierCommentVariant,
} from '@/generated/gql/graphql';

type TranslationFn = (key: string, options?: Record<string, unknown>) => string;

type QuoteItemStatus = TsrctQuoteItemStatus | TsrctSourcingCaseQuoteItemStatus;
type NegotiationFailedReason =
  | TsrctSupplierCommentVariant
  | TsrctSourcingCaseQuoteItemNegotiationFailedReason
  | null
  | undefined;
type BidDeclinedReason = TsrctSourcingCaseQuoteItemBidDeclineReason | null | undefined;

export const getQuoteItemStatusLabel = (t: TranslationFn, status: QuoteItemStatus) => {
  return t(`cell.quoteItemStatus.${status}`);
};

export const getNegotiationFailedReasonLabel = (
  t: TranslationFn,
  reason: NegotiationFailedReason,
  negotiationFailedReasonText?: string | null,
) => {
  return t(`cell.negotiationFailedReason.${reason ?? 'NOT_SPECIFIED'}`, {
    negotiationFailedReasonText,
  });
};

export const getBidDeclinedReasonLabel = (
  t: TranslationFn,
  reason: BidDeclinedReason,
  bidDeclinedReasonText?: string | null,
) => {
  return t(`cell.bidDeclinedReason.${reason ?? 'NOT_SPECIFIED'}`, {
    bidDeclinedReasonText,
  });
};
